import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { UpdateAccountsConfig } from './update-accounts.config';
import { UpdateAccountsComponent } from './update-accounts.component';
import { UpdateAccountCardComponent } from './card';
import ServicesModule from '../../common/services';
import { UpdateAccountsSearchModule } from './search';
import {
  RelevantContentComponent,
  StepPageModule,
} from '../../common/directives';

export const UpdateAccountsStepModule = angular
  .module('app.steps.update-accounts', [
    uiRouter,
    ServicesModule.name,
    UpdateAccountsSearchModule.name,
    RelevantContentComponent.name,
    StepPageModule.name,
  ])
  .config(UpdateAccountsConfig)
  .component('updUpdateAccounts', UpdateAccountsComponent)
  .component('updUpdateAccountCard', UpdateAccountCardComponent);
